import { insertImage } from '../Image/operations';

const slashMenu = {
  'Image Block': { icon: 'image', basic: true, label: 'Image', shortcut: '![Alt text](URL)', transform: insertImage },
};

export default slashMenu;
